import { render } from "./IncomeCalculator.vue?vue&type=template&id=e3483f54&scoped=true"
import script from "./IncomeCalculator.vue?vue&type=script&lang=js"
export * from "./IncomeCalculator.vue?vue&type=script&lang=js"

import "./IncomeCalculator.vue?vue&type=style&index=0&id=e3483f54&scoped=true&lang=css"

import exportComponent from "/home/runner/work/helixpay-website/helixpay-website/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e3483f54"]])

export default __exports__